/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Ip_AddressInputs */



/**
* | output |
* | --- |
* | "IP Address" |
*
* @param {Options_Watermark_Ip_AddressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_ip_address = /** @type {((inputs?: Options_Watermark_Ip_AddressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Ip_AddressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse IP")
	if (locale === "de") return /** @type {LocalizedString} */ ("IP-Adresse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indirizzo IP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("IP-адрес")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dirección IP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("IP 地址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("IP アドレス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आईपी पता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Endereço IP")
	return /** @type {LocalizedString} */ ("IP Address")
});